export const CHAT_OPEN = 'CHAT_OPEN'
export const CHAT_CLOSE = 'CHAT_CLOSE'
export const CHAT_TOGGLE = 'CHAT_TOGGLE'
export const CHAT_SET_UNREAD_COUNT = 'CHAT_SET_UNREAD_COUNT'